import { render, staticRenderFns } from "./SubstanceAdministrationView.vue?vue&type=template&id=5c82f277&scoped=true&"
import script from "./SubstanceAdministrationView.vue?vue&type=script&lang=ts&"
export * from "./SubstanceAdministrationView.vue?vue&type=script&lang=ts&"
import style0 from "./SubstanceAdministrationView.vue?vue&type=style&index=0&id=5c82f277&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c82f277",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VTooltip})
